import React from "react";

const STATUS_MAP = {
  active: {
    label: "Active",
    bg: "bg-[#E6F4EA]",
    text: "text-[#0C6B2E]",
    border: "border-[#A3E0B5]",
    dot: "bg-[#0C6B2E]",
  },
  low: {
    label: "Low",
    bg: "bg-[#FEF3C7]",
    text: "text-[#92400E]",
    border: "border-[#FDE68A]",
    dot: "bg-[#B45309]",
  },
  dormant: {
    label: "Dormant",
    bg: "bg-[#FCE8E8]",
    text: "text-[#C92A2A]",
    border: "border-[#FECACA]",
    dot: "bg-[#C92A2A]",
  },
  none: {
    label: "No posts",
    bg: "bg-[#F1F3F5]",
    text: "text-[#495057]",
    border: "border-[#DEE2E6]",
    dot: "bg-[#868E96]",
  },
};

export function StatusPill({ status = "none" }) {
  const s = STATUS_MAP[status] || STATUS_MAP.none;
  return (
    <span
      data-testid={`status-pill-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border ${s.bg} ${s.text} ${s.border} px-2.5 py-0.5 text-xs font-medium`}
    >
      <span className={`inline-block h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
}
